// @mui material components
import Grid from "@mui/material/Grid";

// MindPlus components
import MDBox from "components/MDBox";

// Settings page components
import BaseLayout from "layouts/pages/account/components/BaseLayout";
import Sidenav from "layouts/users/settings/components/Sidenav";
import Header from "layouts/users/settings/components/Header";
import BasicInfo from "layouts/users/settings/components/BasicInfo";
import ChangePassword from "layouts/users/settings/components/ChangePassword";
import Authentication from "layouts/users/settings/components/Authentication";
import Accounts from "layouts/users/settings/components/Accounts";
import Notifications from "layouts/users/settings/components/Notifications";
import Sessions from "layouts/users/settings/components/Sessions";
import DeleteAccount from "layouts/users/settings/components/DeleteAccount";

function Settings() {
  return (
    <BaseLayout>
      <MDBox mt={4}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={3}>
            <Sidenav />
          </Grid>
          <Grid item xs={12} lg={9}>
            <MDBox mb={3}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Header />
                </Grid>
                <Grid item xs={12}>
                  <BasicInfo />
                </Grid>
                <Grid item xs={12}>
                  <ChangePassword />
                </Grid>
                {/* <Grid item xs={12}>
                  <Authentication />
                </Grid>
                <Grid item xs={12}>
                  <Accounts />
                </Grid>
                <Grid item xs={12}>
                  <Notifications />
                </Grid>
                <Grid item xs={12}>
                  <Sessions />
                </Grid> */}
                <Grid item xs={12}>
                  <DeleteAccount />
                </Grid>
              </Grid>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </BaseLayout>
  );
}

export default Settings;
